import { Box, Text } from '@factorialco/deprecated-design-system'
import { PlannedBreakFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { observer } from 'mobx-react'

import { useTimeFormatted } from 'modules/core/hooks/useTimeFormatted'
import { timeToStringWithTimezone } from 'modules/core/lib/dates'
import { formatToLowerCase } from 'modules/core/lib/formatTime'
import i18n from 'modules/core/lib/i18n'

import type PlannedBreak from 'modules/time_planning/store/internal/models/PlannedBreak'

export interface Props {
  // FIXME: Remove PlannedBreak type once we get rid of the model
  // Right now we are supporting both the mobx store model and the GraphQL type.
  plannedBreak: PlannedBreak | PlannedBreakFragment
  timezone: string
  size: '100' | '200'
}

const TooltipLabel = ({ plannedBreak, timezone, size }: Props) => {
  const formatTime = useTimeFormatted()
  const duration = plannedBreak.duration

  const startAt = plannedBreak.startAt
  const endAt = plannedBreak.endAt

  const from = startAt ? timeToStringWithTimezone(moment(startAt), timezone) : ''
  const to = endAt ? timeToStringWithTimezone(moment(endAt), timezone) : ''

  const formattedStartAt = formatToLowerCase(formatTime(from))
  const formattedEndAt = formatToLowerCase(formatTime(to))

  const breakDetails = () => {
    switch (plannedBreak.breakType) {
      case 'flexible':
        return (
          <Text.Normal color="grey1000" size={size} weight="medium">
            {i18n.t('settings.work_schedule.table_data.breaks.flexible_new', { duration })}
          </Text.Normal>
        )

      // For both fixed and semi-flexible
      default:
        return (
          <>
            <Text.Normal color="grey1000" size={size} weight="medium">
              {i18n.t('settings.work_schedule.table_data.breaks.semi_flexible', {
                duration,
              })}
            </Text.Normal>
            <Text.Normal color="grey1000" size={size} weight="medium">
              {`${formattedStartAt} - ${formattedEndAt}`}
            </Text.Normal>
          </>
        )
    }
  }

  return (
    <Box gap="s4" alignItems="center">
      <Text.Normal color="grey1000" size={size} weight="medium">
        {plannedBreak?.breakConfigurationName}
      </Text.Normal>
      {breakDetails()}
    </Box>
  )
}

export default observer(TooltipLabel)
